import { Skeleton, Stack, Typography } from "@mui/material";

import { FilterTable } from "../../../../../Components/FilterTable/FilterTable";
import {
  type FilterTableItemDescriptor,
  generateHeadersAndFilters,
} from "../../../../../Components/FilterTable/filterTableUtils";
import { type DashboardCluster } from "../../../types";
import { useClusterDashboardContext } from "./context";
import Fsk8sClusterTableRow from "./TableRow";

const Fsk8sClusterTable = () => {
  const { dashboardClusters, loading } = useClusterDashboardContext();

  const itemDescriptions: FilterTableItemDescriptor<DashboardCluster>[] = [
    {
      headerText: "Cluster name",
      value: "name",
      filterType: "string",
    },
    {
      headerText: "Type",
      value: "cloud",
      filterType: "string",
    },
    {
      headerText: "Cost",
      value: "cost",
      filterType: "number",
      headerStyle: { align: "right" },
    },
    // TODO: Add once we have the calculation
    // {
    //   headerText: "Potential savings",
    //   value: "@",
    //   filterType: "number",
    //   headerStyle: { align: "right" },
    // },
    {
      headerText: "Workload count",
      value: "workloads",
      filterType: "number",
      headerStyle: { align: "right" },
    },
    {
      headerText: "CPU utilization (cores)",
      value: "cpuUtilization",
      filterType: "number",
      headerStyle: { align: "right" },
    },
    {
      headerText: "Memory utilization (MiB)",
      value: "memUtilization",
      filterType: "number",
      headerStyle: { align: "right" },
    },
  ];

  if (loading) {
    return <Skeleton variant="rectangular" height={400} />;
  }

  const { headerColumns, filters } = generateHeadersAndFilters(itemDescriptions);

  const clusters = dashboardClusters.clusters ?? [];

  return (
    <Stack>
      <Typography variant="h4" sx={{ mb: -2 }}>
        Clusters ({clusters?.length ?? 0})
      </Typography>
      <FilterTable<DashboardCluster>
        rowComponent={Fsk8sClusterTableRow}
        persistenceKey="fsk8s-clusters-table"
        tableItems={clusters}
        headerColumns={headerColumns}
        filterColumns={filters}
        fillEmptySpace={false}
      />
    </Stack>
  );
};

export default Fsk8sClusterTable;
